module.exports = __webpack_public_path__ + "static/media/bathroom.8d09fd07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Photos/bathroom.jpg
// module id = 525
// module chunks = 0